export default "__VITE_ASSET__Cukk6Tlf__"